import styled from '@emotion/styled'
import {css} from '@emotion/core'

export const TimelineContainer = styled('div')(
  ({theme}) => css`
    padding-top: ${theme.layout.spacing.s400}px;
    display: flex;
    flex-direction: column;
  `
)

export const TitleContainer = styled('div')(
  ({theme}) => css`
    display: flex;
    align-items: center;
    font-size: ${theme.fonts.size.md};
    font-weight: ${theme.fonts.weight.lg};
    line-height: ${theme.fonts.lineHeight.md};
  `
)

export const Circle = styled('div')(
  ({theme}) => css`
    width: 8px;
    height: 8px;
    background-color: ${theme.colors.violet.v300};
    border-radius: 50%;
  `
)

export const StepTitle = styled('div')(
  ({theme}) => css`
    margin-left: ${theme.layout.spacing.s600}px;
  `
)

export const StepDescription = styled('div')`
  display: flex;
`

interface LineProps {
  isLastStep: boolean
}

export const Line = styled('div')<LineProps>(
  ({theme, isLastStep}) => `
    min-width: 2px;
    min-height: 60px;
    border-radius: ${theme.layout.radius.md}px;
    background-color: ${
      isLastStep ? theme.colors.transparent : theme.colors.midnight.m200
    };
    margin: 0 3px;
  `
)

export const StepTextContainer = styled('div')(
  ({theme}) => css`
    margin-left: ${theme.layout.spacing.s600}px;
  `
)
